import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { accountService } from 'src/app/core/service/accountInfo/accountinfo';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.css'],
})
export class AccountInfoComponent implements OnInit {
  notiForm: FormGroup;
  submitted: boolean;
  disableBtn: boolean = false;

  constructor(
    private fb: FormBuilder,
    private account: accountService,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.disableBtn = false;
    this.formInit();
  }
  formInit(): void {
    this.notiForm = this.fb.group({
      email: ['', [Validators.required]],
      colleagueEmail: ['', [Validators.required]],
      staySignedIn: [false],
    });
  }
  get f() {
    return this.notiForm.controls;
  }
  onSave(): void {
    this.submitted = true;
    if (this.notiForm.invalid) {
      return;
    }
    this.disableBtn = true;
    this.account.send(this.notiForm.value).subscribe((res) => {
      if (res.message === 'OTP sent successfully.') {
        sessionStorage.setItem('ui', JSON.stringify(res.data.userId));
        this.router.navigateByUrl('/verify_otp');
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message,
        });
      }
      console.log(res);
    });
    setInterval(() => {
      this.disableBtn = false;
    }, 5000);
  }
}
